// Video tracking (2026-10-23): /for tells our own server (not a third party) how far a company watched its video.
// Company name only, never a person. sendBeacon with a plain string needs no CORS check and never blocks the page.
const EVENTS_URL = `${import.meta.env.VITE_EVENTS_API ?? "https://api.intakall.io"}/api/client-events/video`;

export type VideoEvent = "for.page_opened" | "for.watched" | "for.unmuted" | "for.book_clicked";

export function trackVideo(event: VideoEvent, team: string, extra: { percent?: number } = {}): void {
  if (!team) return;
  try {
    navigator.sendBeacon?.(EVENTS_URL, JSON.stringify({ event, attrs: { team, ...extra } }));
  } catch {
    // Tracking must never break the page.
  }
}
